// extracted by mini-css-extract-plugin
export default {"list":"list__NTQ0Y","item":"item__ODQ1Y"};